<template>
	<span v-if="!$slots.default" :class="classObject" class="icon" v-html="text"/>
	<v-tooltip v-else offset="8" placement="top" trigger="hover">
		<span :class="classObject" class="icon" v-html="text"/>
		<template slot="popover">
			<slot/>
		</template>
	</v-tooltip>
</template>
<script>
export default {
	props: {
		value: {
			type: Boolean,
			default() {
				return false;
			},
		},
		negativeText: {
			required: false,
			type: String,
			default() {
				return "No";
			},
		},
		positiveText: {
			required: false,
			type: String,
			default() {
				return "Yes";
			},
		},
	},

	computed: {
		classObject() {
			return {
				"icon--tick": this.value,
				"icon--x--small": !this.value,
			};
		},
		text() {
			return this.value ? this.positiveText : this.negativeText;
		},
	},
};
</script>
